import { createFileRoute } from "@tanstack/react-router";

import ConnectedAppsPage from "./-components/ConnectedAppsPage";

export const Route = createFileRoute(
  "/_app/_dashboard/integrations/connected-apps"
)({
  component: ConnectedAppsPage,
});
